import { Navigate, useLocation } from 'react-router-dom';
import { Spinner, BlockStack, Text, Box } from '@shopify/polaris';
import { useAuthStore } from '../../store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({
  children,
}: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthStore();

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <Box padding="800">
        <BlockStack gap="400" inlineAlign="center">
          <Spinner size="large" />
          <Text as="p" variant="bodyMd" tone="subdued">
            Loading...
          </Text>
        </BlockStack>
      </Box>
    );
  }

  // Redirect to Track Inquiry if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/track-inquiry" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
